/*
 * ============================================================
 * TREND SHOES — PREMIUM LAYER JS
 * Progressive enhancement only. Safe to fail silently.
 * ============================================================
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll-reveal for .pm-reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.pm-reveal');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pm-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pm-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Sticky header state (for transparent-over-hero) ---------- */
  function initHeaderScroll() {
    var header = document.querySelector('.section-header');
    if (!header) return;

    var onScroll = function () {
      if (window.scrollY > 40) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Cart animations: fly-to-cart, badge bounce, ATC feedback ---------- */

  /**
   * Detect successful cart-add via MutationObserver on #cart-icon-bubble.
   * Avoids needing to import pubsub.js (ES module boundary).
   */
  function initCartAnimations() {
    if (!('MutationObserver' in window)) return;

    var cartBubble = document.getElementById('cart-icon-bubble');
    if (!cartBubble) return;

    function readCount() {
      // Dawn renders <span aria-hidden="true">N</span> inside .cart-count-bubble
      var el = cartBubble.querySelector('[aria-hidden="true"]');
      if (!el) return 0;
      var n = parseInt(el.textContent, 10);
      return isNaN(n) ? 0 : n;
    }

    var lastCount = -1; // -1 = not yet initialised

    var mo = new MutationObserver(function () {
      var count = readCount();
      if (lastCount === -1) {
        lastCount = count; // baseline — no animation on first read
        return;
      }
      if (count > lastCount) {
        lastCount = count;
        onCartAdded();
      } else {
        lastCount = count;
      }
    });

    mo.observe(cartBubble, { childList: true, subtree: true, characterData: true });
    // Capture baseline after a tick (after Dawn's initial section render)
    setTimeout(function () {
      if (lastCount === -1) lastCount = readCount();
    }, 200);
  }

  function onCartAdded() {
    bounceCartBadge();
    showAddedFeedback();
    if (!reduceMotion) flyToCart();
  }

  function bounceCartBadge() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    // Remove + reflow to allow re-triggering the animation
    bubble.classList.remove('pm-cart-pop');
    void bubble.offsetWidth;
    bubble.classList.add('pm-cart-pop');
    setTimeout(function () { bubble.classList.remove('pm-cart-pop'); }, 600);
  }

  function showAddedFeedback() {
    var buttons = [
      document.querySelector('[id^="ProductSubmitButton"]'),
      document.getElementById('pm-satc-btn')
    ];
    buttons.forEach(function (btn) {
      if (!btn || btn.disabled) return;
      // Avoid double-patching if a previous call hasn't expired yet
      if (btn.dataset.pmFeedback) return;
      btn.dataset.pmFeedback = '1';
      var orig = btn.textContent.trim();
      btn.textContent = 'Dodano ✓';
      btn.classList.add('pm-atc-success');
      setTimeout(function () {
        btn.textContent = orig;
        btn.classList.remove('pm-atc-success');
        delete btn.dataset.pmFeedback;
      }, 1500);
    });
  }

  function flyToCart() {
    // Source: sticky bar thumbnail (if bar is active) or first product gallery image
    var srcEl = null;
    var stickyBar = document.getElementById('pm-satc');
    if (stickyBar && stickyBar.classList.contains('pm-satc--on')) {
      srcEl = stickyBar.querySelector('img');
    }
    if (!srcEl) {
      srcEl = document.querySelector('.product__media-wrapper img[src]') ||
              document.querySelector('.product__media img[src]');
    }

    var destEl = document.getElementById('cart-icon-bubble');
    if (!srcEl || !destEl) return;

    var srcRect  = srcEl.getBoundingClientRect();
    var destRect = destEl.getBoundingClientRect();
    if (srcRect.width === 0 || srcRect.height === 0) return;

    // Clamp clone size so it doesn't cover the screen
    var size = Math.min(Math.round(srcRect.width), Math.round(srcRect.height), 64);

    var clone = document.createElement('img');
    clone.src = srcEl.currentSrc || srcEl.src || '';
    if (!clone.src) return;

    clone.style.cssText = [
      'position:fixed',
      'z-index:9998',
      'width:'  + size + 'px',
      'height:' + size + 'px',
      'top:'  + (srcRect.top  + srcRect.height / 2 - size / 2) + 'px',
      'left:' + (srcRect.left + srcRect.width  / 2 - size / 2) + 'px',
      'border-radius:50%',
      'object-fit:cover',
      'pointer-events:none',
      'transition:none',
      'will-change:transform,opacity'
    ].join(';');

    document.body.appendChild(clone);
    void clone.offsetWidth; // reflow before transition

    var dx = (destRect.left + destRect.width  / 2) - (srcRect.left + srcRect.width  / 2);
    var dy = (destRect.top  + destRect.height / 2) - (srcRect.top  + srcRect.height / 2);

    clone.style.transition = 'transform 0.62s cubic-bezier(0.25,0.46,0.45,0.94), opacity 0.5s ease 0.12s';
    clone.style.transform  = 'translate(' + dx + 'px,' + dy + 'px) scale(0.12)';
    clone.style.opacity    = '0';

    setTimeout(function () {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
    }, 780);
  }

  /* ---------- Init ---------- */
  function init() {
    initReveal();
    initHeaderScroll();
    initCartAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run reveal when Shopify theme editor injects sections */
  document.addEventListener('shopify:section:load', initReveal);
})();
